// Keep the Z suffix: a zoneless date string is parsed as local time.
(function () {
    'use strict';

    function pad(n) {
        return n < 10 ? '0' + n : String(n);
    }

    const MONTHS = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const TOKENS = {
        Y: (d) => String(d.getFullYear()),
        y: (d) => pad(d.getFullYear() % 100),
        m: (d) => pad(d.getMonth() + 1),
        n: (d) => String(d.getMonth() + 1),
        M: (d) => MONTHS[d.getMonth()],
        d: (d) => pad(d.getDate()),
        j: (d) => String(d.getDate()),
        D: (d) => DAYS[d.getDay()],
        H: (d) => pad(d.getHours()),
        G: (d) => String(d.getHours()),
        i: (d) => pad(d.getMinutes()),
        s: (d) => pad(d.getSeconds()),
        g: (d) => String(d.getHours() % 12 || 12),
        h: (d) => pad(d.getHours() % 12 || 12),
        A: (d) => (d.getHours() < 12 ? 'AM' : 'PM'),
        a: (d) => (d.getHours() < 12 ? 'am' : 'pm'),
        U: (d) => String(Math.floor(d.getTime() / 1000)),
    };

    function formatPhp(date, format) {
        let out = '';

        for (let i = 0; i < format.length; i++) {
            const ch = format[i];

            if (ch === '\\') {
                i++;
                if (i < format.length) out += format[i];
                continue;
            }

            out += TOKENS[ch] ? TOKENS[ch](date) : ch;
        }

        return out;
    }

    function localise(root) {
        const nodes = (root || document).querySelectorAll('time[data-local-time][datetime]');

        for (let i = 0; i < nodes.length; i++) {
            const el = nodes[i];
            if (el.dataset.localised === '1') continue;

            const when = new Date(el.getAttribute('datetime'));
            if (isNaN(when.getTime())) continue;

            el.textContent = formatPhp(when, el.dataset.localFormat || 'Y-m-d H:i');

            el.title = el.getAttribute('datetime');
            el.dataset.localised = '1';
        }
    }

    window.localiseTimes = localise;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            localise(document);
        });
    } else {
        localise(document);
    }
})();
